import { supabase } from '../supabase/client';
import { getPriceId, PlanTier, BillingInterval } from './client';

// Create a Stripe Checkout Session
export const createCheckoutSession = async (planId: PlanTier, interval: BillingInterval) => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('User not authenticated');

    const response = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/create-checkout-session`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY}`,
      },
      body: JSON.stringify({
        priceId: getPriceId(planId, interval),
        userId: user.id,
        email: user.email,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Failed to parse error response' }));
      console.error('Error response:', errorData);
      throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    if (!data.sessionId) {
      throw new Error('No session ID returned from checkout session creation');
    }

    return data.sessionId;
  } catch (error: any) {
    console.error('Error creating checkout session:', error);
    throw error;
  }
};

// Get customer's subscription status
export const getSubscriptionStatus = async () => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('User not authenticated');

    const response = await fetch('/api/stripe/subscription-status', {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${user.id}`,
      },
    });

    return await response.json();
  } catch (error: any) {
    console.error('Error getting subscription status:', error);
    throw new Error(error.message);
  }
};

// Cancel subscription
export const cancelSubscription = async () => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('User not authenticated');

    const response = await fetch('/api/stripe/cancel-subscription', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${user.id}`,
      },
    });

    return await response.json();
  } catch (error: any) {
    console.error('Error canceling subscription:', error);
    throw new Error(error.message);
  }
};

// Update subscription
export const updateSubscription = async (planId: PlanTier, interval: BillingInterval) => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('User not authenticated');

    const response = await fetch('/api/stripe/update-subscription', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${user.id}`,
      },
      body: JSON.stringify({
        priceId: getPriceId(planId, interval),
      }),
    });

    return await response.json();
  } catch (error: any) {
    console.error('Error updating subscription:', error);
    throw new Error(error.message);
  }
}; 